import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
